module.exports = __webpack_public_path__ + "media/special_attack.3161d73f.mp3";